import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogArticlePage from "../pages/blog/BlogArticlePage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;